import { defineStyleConfig } from "@chakra-ui/react";

export const Table = defineStyleConfig({
  baseStyle: {
    display: "flex",
    flexDirection: "column",
    flex: "0 1 auto",
    overflowY: "hidden",

    ".table": {
      textStyle: "base",
      display: "flex",
      flexDirection: "column",
      overflowY: "hidden",

      ".tr": {
        display: "flex",
        justifyContent: "flex-start",
        gap: "5",
        px: "6",
      },

      ".thead": {
        flex: "0 0 auto",

        ".tr": {
          height: "fit-content",
          bg: "neutral.muted",
          alignItems: "center",
          textStyle: "baseBold",

          ".th": {
            paddingY: "0.5", // extra space for tooltips
            wordBreak: "normal",
          },
        },
      },
      ".tbody": {
        flex: "0 1 auto",
        display: "flex",
        flexDirection: "column",
        overflowY: "auto",

        ".tr": {
          height: "fit-content",
          paddingY: "3",
          alignItems: "center",
          borderTop: "1px solid",
          borderColor: "border.divider",
          cursor: "default",

          ".td": {
            minHeight: "10",
            justifyContent: "center",
          },

          ":first-of-type": {
            borderTop: "none",
          },
        },
      },
    },
  },
});
